import axios from 'axios';

export interface Routering {
  uuid: string;
  digidSysteem: string;
  periodeVan: Date;
  periodeTot: Date;
  status: RouteringStatus;
}

export enum RouteringStatus {
  ACTIEF = 'ACTIEF',
  INACTIEF = 'INACTIEF',
}

const findForUser = async () => {
  const response = await axios.get<Routering[]>(`/ui/routering`);
  return response.data;
};

const findForOrganisation = async (code: string) => {
  const response = await axios.get<Routering[]>(`/ui/routering/search/${code}`);
  return response.data;
};

export const searchForOrganisation = async (orgCode: any, setIsLoading: any, setRouteringen: any, setError: any) => {
  if (!orgCode) {
    return;
  }
  setIsLoading(true);
  try {
    const res = await findForOrganisation(orgCode);
    setRouteringen(res);
    setError(null);
  } catch (err: any) {
    setError(JSON.stringify(err.response?.data || err.message || err, null, 2));
  } finally {
    setIsLoading(false);
  }
};

const activateRouting = async (uuid: string) => {
  return await axios.put<void>(`/ui/routering/${uuid}`);
};

const deactivateRouting = async (uuid: string) => {
  return await axios.delete<void>(`/ui/routering/${uuid}`);
};

const RouteringService = {
  findForUser: findForUser,
  findForOrganisation: findForOrganisation,
  activateRouting: activateRouting,
  deactivateRouting: deactivateRouting,
};

export default RouteringService;
